export default __webpack_public_path__ + "images/V6.27b6cba.png";